import { Utils } from '@genial/utils';
import { Platform } from 'react-native';

import { RiskRating } from '../../../../../../../../../components/RiskRating';
import { FundOfferDetailEntityNormalized } from '../../../../../../../../../store/product/types';
import { onOpenFile } from '../../../../../../../../NewApplication/utils/file';

export const formatFundsDetailsData = (data?: FundOfferDetailEntityNormalized) => {
  if (!data) {
    return [];
  }
  const parsedData = [
    { label: 'Tipo', value: data?.productType || '--' },
    {
      label: 'Rentabilidade 12 Meses',
      value: data?.profitabilityTwelveMonths
        ? Utils.Mask.Percentage(data?.profitabilityTwelveMonths)
        : '--',
    },
    {
      label: 'Risco',
      value: (
        <RiskRating
          currentRiskRating={data?.riskRatingLevel || 0}
          tooltip={data?.riskRating || '--'}
        />
      ),
    },
    { label: 'Perfil Suitability', value: data?.suitabilityProfileName || '--' },
    { label: 'Investimento Inicial', value: Utils.Mask.Money(data?.participateMinimumAmount || 0) },
    { label: 'Movimentação Mínima', value: Utils.Mask.Money(data?.applicationMinimumAmount || 0) },
    {
      label: 'Taxa de Administração',
      value: data?.administrationFee ? data?.administrationFee : '--',
    },
    { label: 'Taxa de Performance', value: data?.performanceFeeDescription || '--' },
    { label: 'Resgate e Liquidação', value: data?.redemptionDescription || '--' },
  ];

  return parsedData;
};

export const formatFundsExtraDetailsData = (data?: FundOfferDetailEntityNormalized) => {
  if (!data) {
    return [];
  }
  const extraData = [
    { label: 'Taxa de Admin.', value: data?.administrationFee || '--' },
    { label: 'Taxa de Performance', value: data?.performanceFeeDescription || '--' },
    {
      label: 'Patrimônio Liquido médio (12M)',
      value: Utils.Mask.Money(parseFloat((data?.averageNetWorth || '').replace(',', '.')) || 0),
    },
    { label: 'Investimento Inicial', value: Utils.Mask.Money(data?.participateMinimumAmount || 0) },
    { label: 'Movimentação Mínima', value: Utils.Mask.Money(data?.applicationMinimumAmount || 0) },
    {
      label: 'Saldo de Permanencia no Fundo',
      value: Utils.Mask.Money(data?.permanenceMinimumAmount || 0),
    },
    {
      label: `Cota em ${
        (data?.lastDateQuotation && Utils.Mask.DateFormat(data?.lastDateQuotation, 'dd/MM')) || '--'
      }`,
      value: (data?.lastQuotationAmount && `R$ ${data.lastQuotationAmount}`) || '--',
    },
    {
      label: 'Rentabilidade nos Últimos 12 Meses',
      value: data?.profitabilityTwelveMonths
        ? Utils.Mask.Percentage(data?.profitabilityTwelveMonths)
        : '--',
    },
    {
      label: 'Rentabilidade desde a constituição',
      value: data?.profitabilitySinceIncorporation
        ? Utils.Mask.Percentage(data?.profitabilitySinceIncorporation)
        : '--',
    },
    { label: 'Aplicação', value: data?.application || '--' },
    { label: 'Resgate e Liquidação', value: data?.redemptionDescription || '--' },
    { label: 'Resgate Antecipado', value: data?.redemptionAntecipated || '--' },
    { label: 'Status do Fundo', value: data?.fundStatus || '--' },
    {
      label: 'Horário limite para Aplicação e Resgate',
      value: data?.timeLimitToTransaction || '--',
    },
    {
      label: 'Data de Constituição do Fundo',
      value: data?.productFormation
        ? Utils.Mask.DateFormat(data?.productFormation, 'dd/MM/yyyy')
        : '--',
    },
    { label: 'IOF', value: data?.iofProductFee || '--' },
    { label: 'Tributação', value: data?.iofProductFee || '--' },
    { label: 'Classificação Anbima', value: data?.anbimaClassification || '--' },
    { label: 'Gestora', value: data?.managerName || '--' },
    { label: 'Administrador', value: data?.administratorName || '--' },
    { label: 'Custódia', value: data?.custodyDescription || '--' },
    { label: 'Auditoria', value: data?.auditorName || '--' },
    { label: 'Código Anbima', value: data?.anbimaCode || '--' },
  ];

  return extraData;
};

export const formatDocumentList = (data?: FundOfferDetailEntityNormalized) => {
  if (!data || !data.documents || !data.documents?.length) {
    return [];
  }

  const documentsList = data.documents.map((item) => {
    const fileIsBase64 = (item?.fileImage || '').length > 0;
    const file = fileIsBase64 ? item?.fileImage : item?.filePath;

    return {
      title: item.documentTypeName || '--',
      onPress: () => Platform.OS === 'web' && onOpenFile(file || '', fileIsBase64),
    };
  });

  return documentsList;
};
